import { getElements, ifSelectorExist } from './utils';

export const scheduleEnginePreventDefault = () => {
  const scheduleEngineLinks = getElements('a[onclick*="ScheduleEngine.show()"]')

  if (ifSelectorExist(scheduleEngineLinks)) {
    scheduleEngineLinks.forEach(link => {
      link.addEventListener('click', e => e.preventDefault())
    });
  }
};